var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVerified = function SvgVerified(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1e88e5",
    d: "M14 1a.7.7 0 0 0-1-.7 12.07 12.07 0 0 1-6 1.55A12.2 12.2 0 0 1 1 .3.69.69 0 0 0 0 1v5.84c0 4.64 2.92 7.69 7 9.16 4.08-1.47 7-4.52 7-9.16Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.43 11.15a1 1 0 0 1-.68-.27L3 8.31a1 1 0 1 1 1.34-1.47l2 1.87 4-4.65a1 1 0 1 1 1.52 1.3L7.18 10.8a1 1 0 0 1-.7.34Z"
  })));
};
export default SvgVerified;